module.exports = __webpack_public_path__ + "static/media/main idea.4548f699.mp3";